import { Controller } from '@hotwired/stimulus'

// Submits a filter form while stripping blank params from the URL.
export default class extends Controller {
  submit(e) {
    e.preventDefault()
    const params = new URLSearchParams([...new FormData(this.element)].filter(([, v]) => v))
    window.location = this.element.action + (params.size ? '?' + params : '')
  }
}
